export const ALM = {
  ALMSummary: {
    Data: {}
  },
  Info: {
    Data: {}
  },
  Loans: {
    Data: []
  },
  Deposits: {
    Data: []
  },
  Investments: {
    Data: []
  }
}
